<style>
.layout.row {
  margin-bottom: 20px !important;
}
</style>

<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12 style="text-align:right">
          <h3 style="float:left">Шаблоны SMS</h3>
          <v-btn color="pink" dark small fab @click="editOpen()">
            <v-icon>add</v-icon>
          </v-btn>
          <v-btn color="blue" dark small fab @click="refresh()">
            <v-icon>refresh</v-icon>
          </v-btn>
        </v-flex>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field flat solo prepend-icon="search" placeholder="Поиск" v-model="search" hide-details
                class="hidden-sm-and-down">
              </v-text-field>
              <v-btn icon>
                <v-icon>filter_list</v-icon>
              </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table :headers="complex.headers" :search="search" :items="templates"
                :rows-per-page-items="[10, 25, 50, 100]" class="elevation-1" item-key="id"
                no-results-text="Нет результатов" rows-per-page-text="На странице" v-model="complex.selected">
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.id }}</td>
                  <td
                    style="background: rgba(251, 247, 239, 0.44);border-left: 1px solid #e0e0e0;border-right: 1px solid #e0e0e0;">
                    <div class="message-bubble">{{ props.item.content }}</div>
                  </td>
                  <td>
                    <v-btn depressed outline icon fab dark color="primary" small @click="editOpen(props.item)">
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn depressed outline icon fab dark color="pink" small @click="removeItemConfirm(props.item)">
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>

              <!-- Редактирование -->
              <div slot="widget-content">

                <v-dialog v-model="popupEdit.isOpen" persistent max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="headline" v-if="editedIndex !== -1">
                        Редактирование
                      </span>
                      <span class="headline" v-if="editedIndex === -1">
                        Добавление
                      </span>
                    </v-card-title>

                    <v-card-text>
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <v-layout row v-if="readonlyFields">
                          <v-flex xs4>
                            <v-subheader>ID</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <span label="ID" readonly>{{ modalData.id }}</span>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Текстовый шаблон</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-textarea label="Текстовый шаблон" v-model="modalData.content" :rules="rules.content"
                              required></v-textarea>
                          </v-flex>
                        </v-layout>
                      </v-form>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn flat @click="editCancel()">Закрыть</v-btn>
                      <v-btn color="primary" flat @click="submit">Сохранить</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

              </div>

              <!-- Удаление -->
              <div slot="widget-content">
                <v-dialog v-model="popupRemove.isOpen" persistent max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">Вы уверены что хотите удалить шаблон?</span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" flat @click.native="popupRemove.isOpen = false">Отмена</v-btn>
                      <v-btn color="blue darken-1" flat @click.native="actionRemove(modalData);">Да, уверен</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>

            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import colors from 'vuetify/es5/util/colors';

export default {
  components: {
  },

  data() {
    return {
      modalData: {},
      oldModalData: {},
      editedIndex: {},
      valid: true,
      readonlyFields: true,
      openColorBox: false,
      colors,
      rules: {
        required: [v => !!v || 'Обязательное поле'],
        code: [
          v => !!v || 'Ключ не может быть пустым',
          v => v.split(' ').length === 1 || 'Нельзя использовать пробелы',
          v => this.templates.filter(el => el.code === v).length === 0 || 'Такой ключ уже существует',
        ],
        content: [
          v => !!v || 'Шаблон не может быть пустым',
        ]
      },
      search: '',
      popupRemove: {
        isOpen: false
      },
      popupEdit: {
        isOpen: false,
        isEditing: false,
      },
      complex: {
        selected: [],
        headers: [
          {
            text: 'ID',
            value: 'id'
          },
          {
            text: 'Наполнение шаблона',
            value: 'content'
          },
          {
            text: 'Действия',
            value: ''
          },
        ],
      }
    };
  },

  mounted: function () {
    /**
     * Загружаем данные по свойствам при первой отрисовке страницы
     */
    if (this.templates.length === 0) {
      this.refresh();
    }
  },

  computed: {
    templates() {
      return this.$store.getters['templatesSms/items'];
    },
  },

  methods: {
    /**
     * Обновление данных по свойствам
     */
    refresh() {
      this.$store.dispatch('templatesSms/loadItems');
    },

    /**
     * Открытие модального окна с редактированием, сохраняем старые данные и индекс элемента на случай отмены редактирования
     * @param item
     */
    editOpen(item) {
      // Если редактирование
      if (item !== null && typeof item !== 'undefined') {
        this.modalData = item;
        this.oldModalData = Object.assign({}, item);
        this.editedIndex = this.templates.indexOf(item);
        this.readonlyFields = true;
        // Если добавление
      } else {
        this.modalData = {
          id: -1,
          content: ''
        };

        this.oldModalData = {};
        this.editedIndex = -1;
        this.readonlyFields = false;
      }

      this.popupEdit.isOpen = true;
    },

    /**
     * Отмена редактирования
     */
    editCancel() {
      if (this.editedIndex != -1) {
        Object.assign(this.templates[this.editedIndex], this.oldModalData);
      }

      this.popupEdit.isOpen = false;
    },

    submit() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('templatesSms/save', { index: this.editedIndex, data: this.modalData })
          .then(() => {
            this.popupEdit.isOpen = false;
          });
      }
    },

    actionRemove(item) {
      this.$store.dispatch('templatesSms/remove', { item });
      this.popupRemove.isOpen = false;
    },

    /**
     * Открытие модального окна с подтверждением удаления
     * @param data
     */
    removeItemConfirm(data) {
      this.popupRemove.isOpen = true;
      this.modalData = data;
    },
  }
};
</script>
<style>
.message-bubble {
  background: white;
  border: 1px solid #8080802b;
  padding: 8px;
  padding-right: 8px;
  padding-left: 8px;
  border-radius: 12px;
  border-top-left-radius: 12px;
  padding-left: 18px;
  padding-right: 18px;
  width: max-content;
  box-shadow: 0px 3px 3px rgba(0, 0, 0, .05);
  border-top-left-radius: 0px;
}
</style>


// WEBPACK FOOTER //
// src/pages/ui/TemplatesSms.vue